
namespace TabAurous.Reports {

    @Serenity.Decorators.registerClass()
    export class StoneBifurcationGrid extends Serenity.EntityGrid<StoneBifurcationRow, any> {
        protected getColumnsKey() { return 'Reports.StoneBifurcation'; }
        protected getIdProperty() { return StoneBifurcationRow.idProperty; }
        protected getInsertPermission() { return StoneBifurcationRow.insertPermission; }
        protected getLocalTextPrefix() { return StoneBifurcationRow.localTextPrefix; }
        protected getService() { return StoneBifurcationService.baseUrl; }
        public vouchertypeid: number;

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }
        protected getButtons() {
            var buttons = super.getButtons();
            let self = this;
            buttons = buttons.filter(x => x.cssClass == "");
            buttons.push({
                title: 'Filters',
                cssClass: 'send-button',
                icon: 'fa-filter',
                onClick: () => {
                    var dialog = new Common.FiltersDialog;
                    dialog.filterformfor = "Transaction";
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            (self.view.params as ReportFiltersRequest).VoucherTypeId = dialog.vouchertypeid;
                            self.vouchertypeid = dialog.vouchertypeid;
                            var vouchernos = dialog.vouchernos;
                            var partyids = dialog.partyids;
                            //self.onViewSubmit();
                            self.view.refresh();
                            StoneBifurcationService.List({ VoucherTypeId: dialog.vouchertypeid, VoucherNos: vouchernos, PartyIds: partyids }, response => { self.view.setItems(response.Entities) }, { async: false });
                        }
                    });
                }
            });
            buttons.push({
                title: 'Export',
                cssClass: 'send-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = self.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }
                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    if (self.vouchertypeid == 55) {
                        Q.postToService({
                            service: StoneBifurcationService.baseUrl + '/SalesQuotationExport',
                            request: {
                                Items: items,
                            },

                            target: '_blank'
                        });
                    } else {
                        Q.postToService({
                            service: StoneBifurcationService.baseUrl + '/OrderDetailSelectedExportExcel',
                            request: {
                                Items: items,
                            },

                            target: '_blank'
                        });
                    }
                }

            });
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Stone Bifurcation"
            }));
            buttons.push(Serenity.ColumnPickerDialog.createToolButton(this as any));
            return buttons;
        }
        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params;

            //var vouchertypeid = request.EqualityFilter.VoucherTypeId;
            //var voucherno = request.EqualityFilter.VoucherNo;
            //var partyids = request.EqualityFilter.PartyId;
            //(this.view.params as ReportFiltersRequest).VoucherTypeId = vouchertypeid;
            //(this.view.params as ReportFiltersRequest).VoucherNo = voucherno;
            //(this.view.params as ReportFiltersRequest).PartyIds = partyids;

            //var x = this.getQuickFilters(); 
            return true;
        }


    }
}